/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

interface IAccountProfileText {
    className: string;
    text: string;
}

const IAccountProfileText: React.FC<IAccountProfileText> = ({ className, text }) => (
    <span className={className}>
        {text}
    </span>
);

export default IAccountProfileText;
